/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import * as api from '../../services'
import * as types from '../types'
import * as alert from './alert'
import { initializedError } from './app'
import { errorsUtils } from '../../utils/errorHandling.utils';

export const logout = () => dispatch => {
  window.localStorage.removeItem('theraytekjwt')
  dispatch({ type: types.user.LOGOUT })
  dispatch(initializedError())
}
export const authenticate = (username, password) => dispatch => {

  return api.user
    .login(username, password)
    .then(theraytekjwt => {
      window.localStorage.setItem('theraytekjwt', theraytekjwt)
      dispatch({ type: types.user.LOGIN })
      return { success: true }
    })
    .catch((error) => {
      console.log(error)
      return error
    })
}
export const getUserInfo = () => dispatch => {

  return api.user
    .getUserMe()
    .then(res => {
      dispatch({ type: types.user.SET_USER,res})

      return { success: true }
    })
}
export const register = (user) => dispatch => {

  return api.user
    .register(user)
    .then(res => {
      dispatch({ type: types.user.REGISTER })

      return res
    }).catch(err => {
      console.log('err', err)
      errorsUtils.handleErrors(err);
      return err
    });
}
export const updateCurrentUser = obj => dispatch => {
  return api.user.patchUserMe(obj).then(res => {
    dispatch({ type: types.user.SET_USER, res})
    return res
  }).catch(err => {
    dispatch(alert.error(err.toString()))
  })
}
export const patchPassword = (pwd) => dispatch => {

  return api.user.patchPassword(pwd).then(res => {
    return res
  }).catch(err => {
    errorsUtils.handleErrors(err);
    return err

  });
}
